import { ID, UUID } from '../../../../types';
import {
  RestoreS3ObjectsCacheKeys,
  RestoreS3ObjectsGqlQuery,
  RestoreS3ObjectsGqlStatus
} from '../../fileAttachmentsTypes';

import { useUpdateQuery } from '../../../common/reactQuery/hooks/useUpdateQuery';

interface RestoreS3ObjectsOptions {
  query: RestoreS3ObjectsGqlQuery;
  cacheKeys?: RestoreS3ObjectsCacheKeys;
}

type RestoreS3ObjectData = {
  uuid: ID | UUID;
  className: string;
  tier: string;
  days: number;
};

type RestoreS3ObjectsData = RestoreS3ObjectData[];

export interface RestoreS3ObjectsInput {
  clientMutationId?: string;
  data: RestoreS3ObjectsData;
}

export interface RestoreS3ObjectsError {
  fullMessages: string[] | null;
}

export interface RestoreS3ObjectsResponse {
  restoreS3Objects: {
    status: RestoreS3ObjectsGqlStatus;
    errors: RestoreS3ObjectsError;
  };
}

const action = 'restoreS3Objects';

function useRestoreS3Objects({ query, cacheKeys }: RestoreS3ObjectsOptions) {
  const {
    updateQueryData,
    updateQuery,
    updateQueryReset,
    updateQueryError,
    updateQueryLoading,
    updateQueryErrorMessage
  } = useUpdateQuery<
    RestoreS3ObjectsInput,
    RestoreS3ObjectsResponse,
    RestoreS3ObjectsError,
    undefined
  >({
    action,
    query,
    cacheKeys
  });

  return {
    restoreS3ObjectsData: updateQueryData,
    restoreS3ObjectsError: updateQueryError,
    restoreS3ObjectsLoading: updateQueryLoading,
    restoreS3ObjectsErrorMessage: updateQueryErrorMessage,
    restoreS3Objects: updateQuery,
    restoreS3ObjectsReset: updateQueryReset
  };
}

export default useRestoreS3Objects;
